import {z} from 'zod';

// The order payment enum also allows INTERNAL and CASH_ON_DELIVERY, which deposits cannot use.
export const depositDefaultPaymentTypeSchema = z.enum(['BANK_TRANSFER', 'CARD', 'CASH']);

export type DepositDefaultPaymentType = z.infer<typeof depositDefaultPaymentTypeSchema>;
